import $ from "jquery"
import "slick-carousel"

const crebosValues = () => {
  const init = () => {
    // Manually apply the border to the first navigation element on page load
    addInitialBorder();

    // Initialize the slick slider
    slick();
  }

  const addInitialBorder = () => {
    const el = {
      navs: ".js-CrebosValues__Navigation",
    }

    // Add border to the first navigation item before Slick initializes
    $(`${el.navs} div[data-thumb="1"] > p`).css("border", "solid 1px #ec6d06");
  }

  const slick = () => {
    const el = {
      slider: ".js-CrebosValues__Slider",
      navs: ".js-CrebosValues__Navigation",
    }

    if ($(el.slider || el.navs).length === 0) return

    // Initialize the main slider
    $(el.slider).slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: el.navs,
      autoplay: true,
      autoplaySpeed: 3000, // Adjust the autoplay speed as needed
      responsive: [
        {
          breakpoint: 575.98,
          settings: {
            adaptiveHeight: true,
          },
        },
      ],
    });

    // Initialize the navigation slider
    $(el.navs).slick({
      rows: 3,
      slidesPerRow: 2,
      infinite: false,
      speed: 1000,
      arrows: false,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      asNavFor: el.slider,
      autoplay: true,
      responsive: [
        {
          breakpoint: 991.98,
          settings: {
            rows: 1,
            slidesPerRow: 1,
            variableWidth: true,
          },
        },
        {
          breakpoint: 767.98,
          settings: {
            rows: 1,
            slidesPerRow: 1,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            rows: 1,
            slidesPerRow: 1,
          },
        },
      ],
    });

    // Helper function to set the border for the active navigation element
    const setActiveNavBorder = (index) => {
      $(`${el.navs} div[data-thumb] > p`).css("border", "none"); // Remove border from all
      $(`${el.navs} div[data-thumb="${index}"] > p`).css("border", "solid 1px #ec6d06"); // Set border for the active one
    }

    // When the main slider is initialized, make sure the border is set correctly on the first navigation element
    $(el.slider).on('init', function (event, slick) {
      const currentSlide = slick.currentSlide + 1; // Slick's `currentSlide` is zero-based, so add 1
      setActiveNavBorder(currentSlide);
    });

    // Sync the navigation border when the main slider changes
    $(el.slider).on('afterChange', function (event, slick, currentSlide) {
      setActiveNavBorder(currentSlide + 1); // Slick's currentSlide is zero-based, so add 1
    });

    // Handle clicks on the navigation to sync the main slider
    let killit = false;
    let currentIndex = 0;
    $(el.navs).find("div").on("click", function (e) {
      if (!killit) {
        e.stopPropagation();
        var idx = $(this).data("thumb");
        $(el.slider).slick("goTo", idx - 1);
        setActiveNavBorder(idx);
        currentIndex = idx;
      }
    });

    // Prevent race conditions between user clicks and autoplay
    $(el.navs)
      .on("beforeChange", function () {
        killit = true;
      })
      .on("afterChange", function () {
        killit = false;
        const indexNow = currentIndex++;
        const totalLength = $(`${el.navs} div[data-thumb]`).length;

        setActiveNavBorder((indexNow % totalLength) + 1); // Set border correctly after change
      });
  }

  init();
}

crebosValues();